import { render, staticRenderFns } from "./PosAddProductData.vue?vue&type=template&id=7a79db8b&scoped=true&"
import script from "./PosAddProductData.vue?vue&type=script&lang=js&"
export * from "./PosAddProductData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a79db8b",
  null
  
)

export default component.exports